import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
	{
		name: 'panelGeneral',
		path: '',
		title: 'Panel General',
		icon: '',
		class: 'nav-small-cap',
		label: '',
		labelClass: '',
		extralink: true,
		submenu: []
	},
	{
		name: 'vistaGeneral',
		path: '/admin/vista-general',
		title: 'Vista General',
		icon: 'mdi mdi-gauge',
		class: '',
		label: '',
		labelClass: '',
		extralink: false,
		submenu: []
	},
	{
		name: 'establecimientos',
		path: '/admin/establecimientos',
		title: 'Establecimientos',
		icon: 'fa fa-hospital-o',
		class: '',
		label: '',
		labelClass: '',
		extralink: false,
		submenu: []
	},
	{
		name: 'formularios',
		path: '/admin/formularios/default',
		title: 'Formularios',
		icon: 'mdi mdi-arrange-send-backward',
		class: '',
		label: '',
		labelClass: '',
		extralink: false,
		submenu: []
	},
	{
		name: 'entregasRealizadas',
		path: '/admin/entregas/lista',
		title: 'Entregas Realizadas',
		icon: 'fa fa-file-text-o',
		class: '',
		label: '',
		labelClass: '',
		extralink: false,
		submenu: []
	},
	{
		name: 'reportes',
		path: '',
		title: 'Reportes',
		icon: 'fa fa-bar-chart',
		class: 'has-arrow',
		label: '',
		labelClass: '',
		extralink: false,
		submenu: [
			{
				name: 'reporteSatisfaccion',
				path: '/admin/reportes/satisfaccion',
				title: 'Satisfacción',
				icon: '',
				class: '',
				label: '',
				labelClass: '',
				extralink: false,
				submenu: []
			},
			{
				name: 'reporteFormularios',
				path: '/admin/reportes/formularios',
				title: 'Formularios',
				icon: '',
				class: '',
				label: '',
				labelClass: '',
				extralink: false,
				submenu: []
			},
			{
				name: 'reporteEstablecimientos',
				path: '/admin/reportes/establecimientos',
				title: 'Establecimientos',
				icon: '',
				class: '',
				label: '',
				labelClass: '',
				extralink: false,
				submenu: []
			}
		]
	},
	{
		name: 'configuracion',
		path: '',
		title: 'Configuración',
		icon: '',
		class: 'nav-small-cap',
		label: '',
		labelClass: '',
		requiresAdminAccess: true,
		extralink: true,
		submenu: []
	},
	{
		name: 'configuracionEstablecimientos',
		path: '/admin/establecimientos-config',
		title: 'Establecimientos',
		icon: 'fa fa-hospital-o',
		class: '',
		label: '',
		requiresAdminAccess: true,
		labelClass: '',
		extralink: false,
		submenu: []
	},
	{
		name: 'configuracionFormularios',
		path: '',
		title: 'Formularios',
		icon: 'mdi mdi-arrange-send-backward',
		class: 'has-arrow',
		label: '',
		requiresAdminAccess: true,
		labelClass: '',
		extralink: false,
		submenu: [
			{
				name: 'listadoFormularios',
				path: '/admin/formularios/listado',
				title: 'Listado de Formularios',
				icon: '',
				class: '',
				label: '',
				labelClass: '',
				extralink: false,
				submenu: []
			},
			{
				name: 'preguntasFormularios',
				path: '/admin/formularios/preguntas',
				title: 'Preguntas',
				icon: '',
				class: '',
				label: '',
				labelClass: '',
				extralink: false,
				submenu: []
			},
			{
				name: 'grupoOpcionesFormularios',
				path: '/admin/formularios/grupo-respuestas',
				title: 'Grupo de Opciones',
				icon: '',
				class: '',
				label: '',
				labelClass: '',
				extralink: false,
				submenu: []
			},
			{
				name: 'respuestasFormularios',
				path: '/admin/formularios/respuestas',
				title: 'Respuestas',
				icon: '',
				class: '',
				label: '',
				labelClass: '',
				extralink: false,
				submenu: []
			}
		]
	},
	{
		name: 'usuarios',
		path: '',
		title: 'Usuarios',
		icon: 'fa fa-users',
		class: 'has-arrow',
		label: '',
		labelClass: '',
		requiresAdminAccess: true,
		extralink: false,
		submenu: [
			{
				name: 'listadoUsuarios',
				path: '/admin/usuarios/listado',
				title: 'Listado de Usuarios',
				icon: '',
				class: '',
				label: '',
				labelClass: '',
				extralink: false,
				submenu: []
			},
			{
				name: 'rolesUsuarios',
				path: '/admin/usuarios/roles',
				title: 'Roles',
				icon: '',
				class: '',
				label: '',
				labelClass: '',
				extralink: false,
				submenu: []
			}
		]
	},
	{
		name: 'politicas',
		path: '',
		title: 'Políticas',
		icon: '',
		class: 'nav-small-cap',
		label: '',
		labelClass: '',
		extralink: true,
		submenu: []
	},
	{
		name: 'privacidad',
		path: '/admin/politicas-de-privacidad',
		title: 'Privacidad',
		icon: 'mdi mdi-lock',
		class: '',
		label: '',
		labelClass: '',
		extralink: false,
		submenu: []
	},
	{
		name: 'terminos',
		path: '/admin/terminos-de-uso',
		title: 'Términos de Uso',
		icon: 'mdi mdi-bullseye',
		class: '',
		label: '',
		labelClass: '',
		extralink: false,
		submenu: []
	},
];
